import { RESOURCE_DOCUMENT_STATUSES, RESOURCE_DOCUMENTS } from '../config';

export const PUBLISHED_RESOURCE_DOCUMENTS = RESOURCE_DOCUMENTS
  .filter((document) => document.status === RESOURCE_DOCUMENT_STATUSES.PUBLISHED);

export const findPublishedResourceDocument = (slug) => PUBLISHED_RESOURCE_DOCUMENTS
  .find((document) => document.slug === slug) || null;

export const getPublishedResourceDocumentSlugs = (ids) => PUBLISHED_RESOURCE_DOCUMENTS
  .filter((document) => ids.includes(document.id))
  .map((document) => document.slug);
